import React from "react";

export default function NoContent({ message }) {
    return (
        <div className="w-full space-x-4 px-14 py-2 mt-10">
            <div className="flex items-center justify-center text-black">
                <span className="flex justify-center text-3xl py-3">
                    {message}
                </span>
            </div>
        </div>
    );
}
